import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CommunityProvider } from "@/context/CommunityContext";
import BottomNav from "@/components/BottomNav";
import Home from "@/pages/Home";
import Walks from "@/pages/Walks";
import WalkDetail from "@/pages/WalkDetail";
import WalkPlayer from "@/pages/WalkPlayer";
import Challenges from "@/pages/Challenges";
import ChallengeDetail from "@/pages/ChallengeDetail";
import Play from "@/pages/Play";
import GameDetail from "@/pages/GameDetail";
import LoserMatch from "@/pages/LoserMatch";
import LoveTree from "@/pages/LoveTree";
import Profile from "@/pages/Profile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Legal from "@/pages/Legal";
import AdminApp from "@/admin/AdminApp";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const hideNav = isAdmin || location.pathname.includes("/los");

  return (
    <>
      <div className={hideNav ? "" : "pb-24"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wege" element={<Walks />} />
          <Route path="/wege/:walkId" element={<WalkDetail />} />
          <Route path="/wege/:walkId/los" element={<WalkPlayer />} />
          <Route path="/challenges" element={<Challenges />} />
          <Route path="/challenges/:challengeId" element={<ChallengeDetail />} />
          <Route path="/spielen" element={<Play />} />
          <Route path="/spielen/:gameId" element={<GameDetail />} />
          <Route path="/loser/:matchId" element={<LoserMatch />} />
          <Route path="/liebesbaum" element={<LoveTree />} />
          <Route path="/profil" element={<Profile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrieren" element={<Register />} />
          <Route path="/rechtliches/:page" element={<Legal />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      {hideNav ? null : <BottomNav />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CommunityProvider>
          <Shell />
          <Toaster position="top-center" />
        </CommunityProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
